import React from "react";
import PageLine from "./PageLine";
import Tabs from './Tabs'

const PageContainer = (props) => {
  const rows = props && props.content_blocks
  const structure = props && props.structure
  const title = props && props.title || "Performance"

  if (structure && structure === 'tabbed') {
    return  (
      <div className="dashboard-page-container">
        {title && <h4 className="bonus-points-layout-header-title">{title}</h4>}
        <p className={ rows && rows.length > 0 ? "hidden" : "" }>A carregar ...</p>
        {rows && rows.length > 0 && <Tabs rows={rows}/> }
      </div>
    )
  }

  return  (
    <div className="dashboard-page-container">
      {title && <h4 className="bonus-points-layout-header-title">{title}</h4>}
      {rows && rows.length > 0 &&
        rows.map((row, key) => (
          <PageLine key={key} {...row} />
        ))
      }
    </div>
  )
}

export default React.memo(PageContainer);
